"use client"
import React, { useState } from "react"
import { useBilling } from "../../../../../context/BillingContext"
import { CurrentPlanProtag, CurrentplanSkeleton } from "../../../../StaticPages/Pages/Skeleton/CurrentplanSkeleton"
import { useRazorpay } from "../../../../../context/RazorpayContext"
import formatDate from "../../../../../common/DateFormate"
import PackageSummaryModal from "../../Razorpay/PackageSummaryModal"

const CurrentPlanCard = ({ openModal }) => {
  const { currentPlan, loading, refetchBilling } = useBilling()
  const { handleCreatePlan ,handlePreviewPlan,invoiceModalData,setInvoiceModalData} = useRazorpay();
  const [isLoading, setIsLoading] = useState(false)
  const formattedDescription = currentPlan?.description
    ?.replace(/\\u003c/g, "<")
    ?.replace(/\\u003e/g, ">")
  // ?.replace(/\n/g, "<br/>");
  const descriptionPoints = formattedDescription
    ?.split("\n")
    ?.filter((line) => line.trim() !== "");

  const handleRegeneratePaymentUrl = async (e) => {
    handlePreviewPlan(e, currentPlan?.id, 'plan', false);
    // await handleCreatePlan(e, setIsLoading, 'generatePaymentUrl',null, refetchBilling)
  }


  return (
    <div className="card h-100 billing-card p-2">

      <div className="card-header h-auto bg-transparent border-0">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="plan-detail-title mb-1 card-title-custom fw-bold">
              {currentPlan?.name}
            </h5>
          </div>
          {loading?.currentPlan ? (
            <CurrentPlanProtag />
          ) : (
            currentPlan?.subscription?.status === 'suspended' ?
              <button className="btn plan-detail-card-btn" onClick={handleRegeneratePaymentUrl}>
                {isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Loading...
                  </>
                ) : <> 🚀 Continue to Re Payment </>
                }
              </button>
              :
              <>
               <button className="btn plan-detail-card-btn" onClick={() => openModal("upgrade")}>Update Plan</button>
              </>
          )}
        </div>
      </div>
      <div className="card-body h-auto py-0">
        {loading?.currentPlan ? <>
          <CurrentplanSkeleton />
        </> : <>
          <div className="mb-3">
            <div className="custom-text-dark h3 fw-bold text-dark mt-2">
              {currentPlan?.price} {(currentPlan?.price && currentPlan?.interval) && <>/ </>}
              <span className="h6 custom-text-dark">{currentPlan?.interval}</span>
            </div>
            {currentPlan?.subscription?.status === 'active' ? <>
              <p className="text-muted text-next-billing ">Billing Cycle &nbsp;
                {currentPlan?.subscription?.billing_cycle}
              </p>
            </> : <>
              <div className="alert alert-danger py-2 position-absolute bottom-0 mb-3">
                <small className="text-danger-emphasis">
                  Your plan is currently suspended. Click "Continue to Re Payment" to reactivate it.
                </small>
              </div>
            </>
            }
          </div>
        </>}
      </div>
    </div>
  )
}

export default CurrentPlanCard
